import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactLegal = () => {
  const contactMethods = [
    {
      icon: "Mail",
      title: "Email Support",
      value: "legal@mava.in",
      description: "For legal inquiries and clarifications",
      action: "mailto:legal@mava.in"
    },
    {
      icon: "Phone",
      title: "Legal Helpline",
      value: "+91 98765 43210",
      description: "Monday to Friday, 9:00 AM - 6:00 PM IST",
      action: "tel:+919876543210"
    },
    {
      icon: "MapPin",
      title: "Registered Office",
      value: "Mava Beverages Pvt. Ltd.",
      description: "123 Business Park, Sector 18\nGurgaon, Haryana 122015, India",
      action: null
    }
  ];

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/20 rounded-lg p-6 mb-8">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Scale" size={32} className="text-primary" />
        </div>
        <h3 className="font-poppins font-bold text-xl text-text-primary mb-2">
          Legal Inquiries & Support
        </h3>
        <p className="text-text-secondary font-inter">
          Have questions about our terms? Our legal team is here to help.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        {contactMethods?.map((method, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-4 text-center">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
              <Icon name={method?.icon} size={20} className="text-primary" />
            </div>
            <h4 className="font-poppins font-semibold text-text-primary mb-1">
              {method?.title}
            </h4>
            <p className="font-inter font-medium text-primary mb-1">
              {method?.value}
            </p>
            <p className="text-sm text-text-secondary whitespace-pre-line">
              {method?.description}
            </p>
            {method?.action && (
              <Button
                variant="outline"
                size="sm"
                className="mt-3 w-full"
                onClick={() => window.open(method?.action)}
              >
                Contact
              </Button>
            )}
          </div>
        ))}
      </div>
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Clock" size={20} className="text-accent mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="font-poppins font-semibold text-accent mb-1">
              Response Time
            </h4>
            <p className="text-sm text-text-primary">
              We typically respond to legal inquiries within 2-3 business days. For urgent matters, 
              please call our legal helpline during business hours.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactLegal;